import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import SupportButton from './hoverButton';
import { Send } from '@material-ui/icons';
import { useDispatch, useSelector } from 'react-redux';
import { getContactSupportListAction, createContactSupporRequestAction } from '../../containers/contactSupport/action';
import PageLoading from './pageLoading';
import theme from '../../theme';

import ContactSupportForm from './contactSupportSubmitForm';

const useStyles = makeStyles((th) => ({
    supportContainer: {
        position: 'fixed',
        bottom: th.spacing(4),
        right: th.spacing(4),
        zIndex: 1300,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        overflowY: "scroll"
    },
    supportPopup: {
        marginBottom: th.spacing(1),
        padding: th.spacing(2),
        // maxWidth: 260,
        width: "380px",
        backgroundColor: th.palette.background.paper,
        boxShadow: th.shadows[3],
    },
    sendIcon: {
        cursor: "pointer",
        transition: "color .5 ease-in-out",
        "&:hover": {
            color: theme.colors.DodgerBlue
        }
    },
}));

export default function SupportContainer() {
    const classes = useStyles();
    const [open, setOpen] = useState(false);
    const [filters, setFilters] = useState({})
    const [showMakeRequest, setShowMakeRequest] = useState(false)
    const [submitted, setSubmitted] = useState(false)
    const [form, setForm] = useState({ subject: "", description: "" })

    const dispatch = useDispatch()
    const contactSupportReducer = useSelector(state => state.contactSupportReducer)
    const getContactSupportListActionMethod = React.useCallback(
        (data) => getContactSupportListAction(data),
        [filters]
    )

    const createContactSupporRequestActionMethod = React.useCallback(
        data => createContactSupporRequestAction(data),
        [form]
    )

    const handleToggleSupport = (e) => {

        setOpen((prev) => !prev);
        setShowMakeRequest(false)
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(createContactSupporRequestActionMethod(form))
        setSubmitted(true)
    }



    React.useEffect(() => {
        dispatch(getContactSupportListActionMethod(filters))
    }, [filters])

    return (
        <div className={classes.supportContainer}>
            {contactSupportReducer?.error?.length ? (
                <div className={"error-container"}>
                    {contactSupportReducer?.error?.map((each, index) => (
                        <div key={index}>{each}</div>
                    ))}
                </div>
            ) : null}
            {open && (
                <>                {
                    !showMakeRequest ? (
                        <Paper className={classes.supportPopup}>
                            {
                                contactSupportReducer?.loading ? <PageLoading /> : null
                            }
                            <div>
                                <Typography variant="subtitle1" gutterBottom>
                                    Need help?
                                </Typography>
                                <Typography variant="body2">
                                    Send A Request
                                </Typography>
                            </div>
                            <Send className={classes.sendIcon} onClick={() => setShowMakeRequest(s => !s)} />
                        </Paper >) : (
                        <ContactSupportForm
                            setSubmitted={setSubmitted}
                            submitted={submitted}
                            backAction={() => { setShowMakeRequest(false) }}
                            form={form}
                            setForm={setForm}
                            handleSubmit={handleSubmit}
                        />
                    )
                }
                </>

            )}
            <SupportButton
                onClick={handleToggleSupport}
            />
        </div>
    );
}
